import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import type { OzonStoresResponse, SyncKey } from "./ozon-stores-types";
import type { StepResult, SyncStatusResponse } from '../WbStores/wb-stores-api';

function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  };
}

const api = axios.create({ baseURL: ROOT_URL, withCredentials: false });

const syncMethod: Record<SyncKey, "get" | "post"> = {
  products: "post",
  stocks: "post",
  finances: "post",
  analytics: "post",
  performance: "get",
  forecasts: "post",
};

export function getOzonStores(params: {
  query?: string;
  sync_status?: string;
  page?: number;
  limit?: number;
}): Promise<OzonStoresResponse> {
  return api
    .get("/api/admin/ozon-stores", { headers: getHeaders(), params })
    .then((res) => res.data);
}

export function syncOzonStore(connectionUuid: string, key: SyncKey): Promise<void> {
  const method = syncMethod[key];
  const url = `/api/admin/ozon-stores/${connectionUuid}/sync/${key}`;
  const headers = getHeaders();
  const req =
    method === "get"
      ? api.get(url, { headers })
      : api.post(url, undefined, { headers });
  return req.then(() => undefined);
}

export type { StepResult, SyncStatusResponse };

export const getOzonSyncStatus = async (connectionUuid: string): Promise<SyncStatusResponse> => {
  return api
    .get(`/api/admin/ozon-stores/${connectionUuid}/sync/status`, { headers: getHeaders() })
    .then((res) => res.data);
};

export const enqueueOzonJob = async (
  connectionUuid: string,
  type: 'initial_sync' | 'daily_sync'
): Promise<{ job_id: number }> => {
  return api
    .post(`/api/admin/ozon-stores/${connectionUuid}/jobs/enqueue`, { type }, { headers: getHeaders() })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 409) throw new Error('CONFLICT');
      throw err;
    });
};
